import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {GET_DOCUMENTS, GET_DOCUMENTS_FULL} from "../../queries/documentsQuery.js";
import TemplateList2 from "../../components/TemplateList/TemplateList.2.0.jsx";
import styleHomePage from "./home.css";


function Home() {
    const navigate = useNavigate();
    //const documentType = new URLSearchParams(search).get('documentType');
    
    const apiBaseUrl = process.env.NODE_ENV === "development"
        ? "http://localhost:4000"
        : "";

    console.log(process.env.NODE_ENV);
    console.log("apiBaseUrl", apiBaseUrl);

    return (
        <div className="center-container">
            {/*<div className="banner-container">*/}
            <div className="title-container">
                {/*<img alt="Tageos" src="logo-tageos-vertical.svg" />
                <img alt="Zento" src="logo.svg" />
                <span>Tageos CraftMyPdf</span>*/}
            </div>{/*}</div>*/}
            {/* ✅ Template List with Correct Layout */}
            {/*<TemplateList onTemplateSelect={generateProgTemplatePrint} />*/}
            <TemplateList2 apiBaseUrl={apiBaseUrl} />
        </div>
    );
}

export default Home;